import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV, LOGO } from "../data/site";
import { useQuote } from "./QuoteModal";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openQuote } = useQuote();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        data-testid="navbar"
        initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className={`fixed top-0 left-0 w-full z-[80] transition-all duration-500 ${scrolled ? "glass-nav border-b border-white/10 py-2" : "py-4"}`}
      >
        <div className="container-lux flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
            <img src={LOGO} alt="Sterling Roofworks" className={`transition-all duration-500 ${scrolled ? "h-10" : "h-12"}`} />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <a key={n.href} href={n.href} data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="font-head text-sm uppercase tracking-wider text-[#C8C8C8] hover:text-[#D4AF37] transition-colors relative group">
                {n.label}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-[#D4AF37] group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button data-testid="nav-get-quote" onClick={openQuote}
              className="hidden sm:inline-flex btn-gold rounded-sm px-5 py-2.5 text-xs">
              Get Free Quote
            </button>
            <button data-testid="nav-menu-toggle" className="lg:hidden text-white" onClick={() => setOpen(true)}>
              <Menu size={26} strokeWidth={1.5} />
            </button>
          </div>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-[95] bg-[#0D0D0D]/95 backdrop-blur-xl flex flex-col p-8"
            initial={{ opacity: 0, x: "100%" }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: "100%" }}
            transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.4 }}
          >
            <button data-testid="mobile-menu-close" className="self-end text-white" onClick={() => setOpen(false)}>
              <X size={30} strokeWidth={1.5} />
            </button>
            <nav className="flex flex-col gap-6 mt-10">
              {NAV.map((n, i) => (
                <motion.a key={n.href} href={n.href} onClick={() => setOpen(false)}
                  initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.06 * i }}
                  className="font-head text-3xl uppercase tracking-tight text-[#F8F8F8] hover:text-[#D4AF37] transition-colors">
                  {n.label}
                </motion.a>
              ))}
              <button onClick={() => { setOpen(false); openQuote(); }} className="btn-gold rounded-sm px-6 py-4 mt-4 text-sm">
                Get Free Quote
              </button>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
